import React from "react";
import { Progress } from "semantic-ui-react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CheckIcon from "@mui/icons-material/Check";

const listitems = [
  {
    num: "1",
    name: "Personal Details",
  },
  {
    num: "2",
    name: "Bank Account Details",
  },
  {
    num: "3",
    name: " Documents",
  },
];

interface mainListContainerProps {
  onClick?: () => void;
  percent: number;
}

const MainListContainer: React.FC<mainListContainerProps> = ({
  onClick,
  percent,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: { xs: "94%", sm: "300px", md: "350px", xl: "366px" },
          height: { xs: "235px", sm: "270px", md: "220px", xl: "230px" },
          borderColor: "#707070",
          borderRadius: 4,
          borderStyle: "solid",
          borderWidth: 0.5,
          color: "gray",
          margin: { xs: "10px", sm: "0px" },
        }}
      >
        <Box
          sx={{
            padding: "25px",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "16px", md: "18px" },
              lineHeight: { xs: "12px", sm: "24px", md: "26px" },
              color: "#333333",
              opacity: 1,
              fontFamily: "Avenir",
            }}
            component="div"
          >
            Setting up your oDoc profile
          </Typography>
          <Box
            sx={{
              width: { xs: "100%", sm: "250px", md: "300px" },
              paddingTop: { xs: "20px", sm: "10px" },
              paddingBottom: "10px",
            }}
          >
            <Progress
              percent={percent}
              color={"blue"}
              size={"tiny"}
              style={{
                marginBottom: "0px",
              }}
            />
          </Box>
          {listitems.map((num, name) => (
            <React.Fragment key={num.name}>
              <Box
                sx={{
                  padding: "10px",
                  paddingLeft: "0px",
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {percent === 0 && (
                  <Box
                    sx={{
                      borderWidth: "1px",
                      width: { xs: "29px", sm: "22px" },
                      height: { xs: "29px", sm: "22px" },
                      borderRadius: 15,
                      borderColor: "#70707080",
                      display: "block",
                      borderStyle: "solid",
                      textAlign: "center",
                      fontSize: { xs: "13px", sm: "13px" },
                      lineHeight: { xs: "18px", sm: "18px" },
                      marginLeft: 1,
                      opacity: 0.5,
                      fontFamily: "Lato",
                      marginRight: "12px",
                    }}
                  >
                    {num.num}
                  </Box>
                )}
                {percent === 100 && (
                  <CheckIcon
                    sx={{
                      borderWidth: "1px",
                      color: "#FFFFFF",
                      width: { xs: "29px", sm: "22px" },
                      height: { xs: "29px", sm: "22px" },
                      borderRadius: 15,
                      borderColor: "#70707080",
                      display: "block",
                      borderStyle: "solid",
                      textAlign: "center",
                      fontSize: { xs: "13px", sm: "13px" },
                      lineHeight: { xs: "18px", sm: "18px" },
                      marginLeft: 1,
                      opacity: 1,
                      fontFamily: "Lato",
                      marginRight: "12px",
                      backgroundColor: "#2685F8",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "12px",
                      md: "12px",
                    },
                    lineHeight: {
                      xs: "12px",
                      sm: "16px",
                      md: "16px",
                    },
                    color: "#333333",
                    opacity: 0.5,
                    fontFamily: "Avenir",
                  }}
                  component="div"
                >
                  {num.name}
                </Typography>
              </Box>
            </React.Fragment>
          ))}
        </Box>
        {onClick && (
          <Button
            sx={{
              fontSize: {
                xs: "19px",
                sm: "10px",
                md: "14px",
                xl: "20px",
              },
              lineHeight: {
                xs: "12px",
                sm: "10px",
                md: "9px",
                xl: "12px",
              },
              color: "#ffffff",
              fontWeight: "900",
              fontFamily: "Avenir",
              textTransform: "unset",
              padding: "18px",
              backgroundColor: "#2685F8",
              borderRadius: "4px",
              marginTop: "15px",
              width: "100%",
              display: { xs: "set", sm: "none" },
            }}
            onClick={onClick}
          >
            Create My Profile
          </Button>
        )}
      </Box>
    </React.Fragment>
  );
};

export default MainListContainer;
